export default __webpack_public_path__ + "static/media/592.2a14b9da.gif";